import { createCommand } from '../../utils';
import { moduleName, rubricToDisplayIdsUpdated } from '../state';
import { UpdateFiltersCommand } from './UpdateFiltersCommand';

export const RemoveRubricsToDisplayIdCommand = createCommand(
    `${moduleName}/REMOVE_REFERENCES_TO_DISPLAY_ID`,
    async (rubricId: string, { dispatch, extra }) => {
        const previouslyStoredRubricIds: Array<string> = [];
        const rubricIdsFromProvider = extra.storageProvider.getRubricIds();
        if (rubricIdsFromProvider) {
            previouslyStoredRubricIds.push(...rubricIdsFromProvider);
        }

        const newStoredRubricIds: Array<string> = previouslyStoredRubricIds.filter((e) => !(rubricId === e));

        extra.storageProvider.setRubricIds(newStoredRubricIds);
        dispatch(rubricToDisplayIdsUpdated({ rubricIds: newStoredRubricIds }));

        dispatch(UpdateFiltersCommand());
    },
);
